import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Input from "../shared/Input";
import { fetchData, fetchFormData, getValueLabel } from "../../utils/options";
import topTost from "../../utils/topTost";
import TextArea from "../shared/TextArea";
import SelectDropdown from "../shared/SelectDropdown";
import { IBaseUrl } from "../..";

const Expense_CategoryCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");

  const today = new Date().toISOString().split("T")[0];

  const [expenseCategory, setExpenseCategory] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  const fetchDetails = async (id) => {
    const formData = new FormData();
    formData.append("id", id); // Send ID in the form data
    formData.append("created_by", userId);
    formData.append("moduleId", M_id);
    formData.append("userId", userId);
    try {
      const result = await fetchFormData(
        "expense-category-Byid",
        formData,
        "POST"
      );

      if (result && result.data) {
        setExpenseCategory(result.data.expense_category);
      } else {
        console.warn("data not found.");
        setExpenseCategory([]);
      }
    } catch (error) {
      console.error("Failed to fetch details:", error);
      setExpenseCategory([]);
    }
  };

  useEffect(() => {
    if (id) {
      fetchDetails(id);
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Create a FormData object
    const formData = new FormData();
    formData.append("created_by", userId);
    formData.append("moduleId", M_id);
    formData.append("expense_category", expenseCategory);

    try {
      let res;

      if (id) {
        formData.append("id", id);
        formData.append("userId", userId);
        // Edit logic - update
        res = await fetchFormData("update-expense-category", formData, "POST");
      } else {
        // Create logic - new
        res = await fetchFormData("add-expense-category", formData, "POST");
      }

      if ((res && res.code === 200) || 201) {
        navigate(`/master/expense-category-list?id=${M_id}`);
        topTost({
          title: res.message,
          icon: "success",
        });

        console.log(" operation successful", res);
      } else if (res && res.code === 422) {
        topTost({
          title: res.message,
          icon: "success",
        });
        navigate(`/master/expense-category-list?id=${M_id}`);
        console.log(" operation successful", res);
      } else {
        console.error(" operation failed", res);
      }
    } catch (error) {
      console.error("Submit error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="col-lg-12">
        <div className="card stretch stretch-full">
          <hr className="mt-0" />
          <div className="card-body general-info">
            <div className="mb-5 d-flex align-items-center justify-content-between">
              <h5 className="fw-bold mb-0 me-4">
                <span className="d-block mb-2">
                  {id ? "Edit Expense Category:" : "Add Expense  Category :"}
                </span>
              </h5>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <Input
                    icon="feather-briefcase"
                    label="Expense Category"
                    labelId="Input"
                    placeholder="Expense Category"
                    name="expenseCategory"
                    value={expenseCategory}
                    required
                    onChange={(name, value) => setExpenseCategory(value)}
                  />
                </div>
                <div className="col-md-6">
                  <button
                    type="submit"
                    className="btn btn-lg btn-primary"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Submitting..." : id ? "Update" : "Submit"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Expense_CategoryCreate;
